import { getDomainConfigValue } from '@src/model/config/helpers';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

declare global {
    interface Window {
        ramp: any;
        vx: any;
    }
}

export interface UsePlaywireRamp {
    isLoaded: boolean;
}

const usePlaywireRamp = (): UsePlaywireRamp => {
    const location = useLocation();

    const isLoaded = Boolean(window.ramp?.que);

    // Get config from domain config or props
    const playWireAdConfig = getDomainConfigValue('playWireAd');
    if (!playWireAdConfig) {
        console.warn('[PlaywireRamp] No Playwire configuration found');
        return { isLoaded: false };
    }
    const { pubId, websiteId } = playWireAdConfig;

    if (websiteId === '75996' && !location.pathname.startsWith('/FALLT')) return { isLoaded: false };

    const initPlaywireRamp = () => {
        if (!pubId || !websiteId) {
            console.log('[PlaywireRamp] Missing Publisher Id and Website Id');
            return;
        }
        if (!window.ramp) {
            window.ramp = window.ramp || {};
            window.ramp.que = window.ramp.que || [];
            window.ramp.passiveMode = true;

            // Load the Ramp configuration script
            const configScript = document.createElement('script');
            configScript.src = `https://cdn.intergient.com/${pubId}/${websiteId}/ramp.js`;

            configScript.onload = () => {
                console.log(`[PlaywireRamp] Ramp component loaded with Publisher ID: ${pubId} and Website ID: ${websiteId}`);
                window.ramp?.que?.push(() => {
                    window.ramp?.spaNewPage?.(location.pathname);
                });
            };

            document.body.appendChild(configScript);
        }

        if (!window.vx) {
            window.vx = window.vx || {};
            console.log('[PlaywireRamp] Injecting Jivox script');
            // Inject Jivox script
            const jsrdnScript = document.createElement('script');
            jsrdnScript.async = true;
            jsrdnScript.type = 'text/javascript';
            jsrdnScript.src = '//c.jsrdn.com/s/cs.js?p=23222';

            document.head.appendChild(jsrdnScript);
        }
    };

    useEffect(() => {
        initPlaywireRamp();

        // Cleanup function to handle component unmount
        return () => {
            if (window.ramp?.que) {
                window.ramp.que.push(() => {
                    window.ramp?.spaNewPage?.(location.pathname);
                });
            }
        };
    }, [location.pathname]);

    return { isLoaded };
};

export default usePlaywireRamp;
